import React from "react";

const ProductCard = ({ product, onClick }) => {
  // Normalize the image path to ensure cross-platform compatibility
  const normalizedImage = product.image.replace(/\\/g, "/");

  return (
    <div
      style={{
        border: "1px solid #ccc",
        margin: "10px",
        padding: "10px",
        width: "250px",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        cursor: "pointer", // Add cursor styling for clickable cards
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
      }}
      onClick={onClick} // Pass the onClick handler if provided
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")} // Hover effect
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <h2 style={{ fontSize: "18px", margin: "10px 0", textAlign: "center" }}>
        {product.name}
      </h2>
      <img
     
  src={
    product.image.startsWith("http")
      ? product.image
      : `https://res.cloudinary.com/ddv0dhxf6/image/upload/relison-products/${product.image.split("\\").pop()}`
  }
  alt={product.name}

        style={{
          width: "100%",
          height: "150px",
          objectFit: "cover",
          borderRadius: "4px",
        }}
      />
      <p
        style={{
          fontSize: "14px",
          color: "#555",
          marginTop: "10px",
          textAlign: "center",
        }}
      >
        {product.description}
      </p>
    </div>
  );
};

export default ProductCard;
